import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import { trackOptionsAvailable } from '@jsmdg/tracking';
import { type ProductType } from '../../../shared/enums';
import { type ProductGroupItem as ProductGroupItemType } from '../../../shared/types';
import { buildProductGroup } from './ProductGroupBuilder';

type ProductGroupProps = {
    productType: ProductType;
    selectedProductId: string;
    items?: ProductGroupItemType[];
    isRedemptionCartFilled: boolean;
};

const ProductGroup = ({
    isRedemptionCartFilled,
    items = [],
    productType,
    selectedProductId,
}: ProductGroupProps): JSX.Element | null => {
    const intl = useIntl();
    const [selectedGroupItemId, setSelectedGroupItemId] = useState(selectedProductId);
    const productGroup = buildProductGroup({
        items,
        selectedItemId: selectedGroupItemId,
        setSelectedItemId: setSelectedGroupItemId,
        intl,
        isRedemptionCartFilled,
        productType,
    });

    useEffect(() => {
        trackOptionsAvailable(productGroup.canRender);
    }, [productGroup.canRender]);

    return productGroup.body;
};

export { ProductGroup };
